import React from "react";
import AboutSection from "../components/AboutSection";
import AboutFounder from "../components/AboutFounder";
import MissionVision from "../components/MissionVision";
import OurProcess from "../components/OurProcess";
import NeedAbout from "../components/NeedAbout";
import SmarterMove from "../components/SmarterMove";
import Journey from "../components/Journey";
import WhyChooseRecla from "../components/WhyChooseRecla";
import "./About.css";

const About = () => {
  return (
       <section className="About">
      {/* Top Section (Like Contact Us Style) */}
      <div className="aboutheadermain">
        <h2 className="abouttitlemain">About Us</h2>
      </div>

          {/* About Section */}
          <AboutSection />
          {/* About Founder Section */}
          <AboutFounder />
       
          {/* About Mission Section */}
          <MissionVision /> 
          {/* About ourprocess Section */}
          <OurProcess />
               <WhyChooseRecla />
             {/* Other About content */}
          <Journey />
          <SmarterMove/>
                
 
    </section>    
  );
};

export default About;
